import axios from '@/plugins/api.request'

/**
 * 列表
 * @param {*} params
 */
 export const subjectList = (params) => {
  return axios.request({
    method: 'get',
    url: 'edu.subject/list',
    params
  })
}

/**
 * 列表
 * @param {*} params
 */
export const courseList = (params) => {
  return axios.request({
    method: 'get',
    url: 'edu.course/list',
    params
  })
}

/**
 * 课程详情
 * @param {*} params
 */
 export const courseDetail = (params) => {
  return axios.request({
    method: 'get',
    url: 'edu.course/detail',
    params
  })
}

/**
 * 章节详情
 * @param {*} params
 */
 export const chapterDetail = (params) => {
  return axios.request({
    method: 'get',
    url: 'edu.course/chapterDetail',
    params
  })
}

/**
 * 学生完成资料
 * @param {*} params
 */
 export const studentFinishResource = (params) => {
  return axios.request({
    method: 'get',
    url: 'edu.course/finishResource',
    params
  })
}

/**
 * 教师获取已开通列表
 * @param {*} params
 */
 export const courseListByPass = (params) => {
  return axios.request({
    method: 'get',
    url: 'edu.course/listByPass',
    params
  })
}